import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center bg-[#F5F2EA] px-6"
    >
      <div className="w-full max-w-md bg-white border border-[#C5A059]/30 p-10">
        <Link
          to="/"
          data-testid="back-to-site-link"
          className="text-[11px] uppercase tracking-[0.28em] text-[#A4863F] hover:text-[#0F5C46]"
        >
          ← Back to site
        </Link>
        <div className="mt-6 flex items-center gap-3">
          <div className="w-10 h-10 border border-[#C5A059]/50 flex items-center justify-center">
            <Lock className="w-4 h-4 text-[#0F5C46]" />
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#A4863F]">
              Administration
            </p>
            <h1 className="font-serif text-3xl text-[#1A1A1A] leading-none">
              Sign in
            </h1>
          </div>
        </div>

        <form onSubmit={onSubmit} className="mt-8 space-y-5">
          <div>
            <Label
              htmlFor="email"
              className="text-[11px] uppercase tracking-[0.2em] text-[#4A4A4A]"
            >
              Email
            </Label>
            <Input
              id="email"
              type="email"
              required
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 rounded-none border-[#C5A059]/40 focus-visible:ring-[#0F5C46] focus-visible:ring-1"
            />
          </div>
          <div>
            <Label
              htmlFor="password"
              className="text-[11px] uppercase tracking-[0.2em] text-[#4A4A4A]"
            >
              Password
            </Label>
            <Input
              id="password"
              type="password"
              required
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 rounded-none border-[#C5A059]/40 focus-visible:ring-[#0F5C46] focus-visible:ring-1"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#059669] text-white uppercase tracking-[0.18em] text-sm font-medium px-6 py-3.5 hover:bg-[#0F5C46] transition-colors disabled:opacity-50"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </main>
  );
}
